import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Contact.css';

export const Contact: React.FC = () => {
  return (
    <div className="contact-container">
      <Helmet>
        <title>Contact Us | Rent Small Offices in Bagshot</title>
        <meta name="description" content="Get in touch with David Smith to arrange a viewing or inquire about renting our small office units in Bagshot." />
        <link rel="canonical" href="https://www.bagshot-offices.co.uk/contact" />
      </Helmet>
      <h1>Contact Us</h1>
      <p className="contact-intro">
        Interested in renting an office unit or arranging a viewing? Get in touch with David Smith today.
      </p>
      
      <div className="contact-details">
        <div className="contact-item">
          <strong>Email:</strong>{' '}
          <a href="mailto:david.smith@tsaservices.co.uk">
            david.smith@tsaservices.co.uk
          </a>
        </div>
        
        <div className="contact-action">
          <a href="mailto:david.smith@tsaservices.co.uk" className="email-cta-button">
            Email David Smith
          </a>
        </div>

        <div className="contact-item">
          <strong>Our Address:</strong> 1st Floor, 57B High Street, Bagshot, Surrey, GU19 5AH
        </div>
      </div>
    </div>
  );
};
